import { ParsedUrlQuery } from 'querystring';

export function toQueryString(query: ParsedUrlQuery): string {
  const filteredEntries: [string, string][] = Object.entries(query)
    .filter(([key]) => key !== 'slug' && query[key] !== undefined)
    .map(([key, value]) => [
      key,
      Array.isArray(value) ? value[0] : value, // use first value if it's an array
    ]);

  return new URLSearchParams(filteredEntries).toString();
}
